var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48667 0H3.51333L0 3.51333V8.48667L3.51333 12H8.48667L12 8.48667V3.51333L8.48667 0ZM9.33333 8.49333L8.49333 9.33333L6 6.84L3.50667 9.33333L2.66667 8.49333L5.16 6L2.66667 3.50667L3.50667 2.66667L6 5.16L8.49333 2.66667L9.33333 3.50667L6.84 6L9.33333 8.49333Z",
    fill: "#BA1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5c6e9bb6.svg";
export { ForwardRef as ReactComponent };